var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUltra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 59,
    viewBox: "0 0 337 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.44V0H11.21V35.44C11.21 42.61 16.48 47.47 25.22 47.47C33.96 47.47 39.23 42.61 39.23 35.44V0H50.52V35.44C50.52 48.87 40.22 58.68 25.22 58.68C10.22 58.68 0 48.87 0 35.44Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3604 0H90.5704V46.65H122.55V58.02H79.3704V0H79.3604Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 11.37H135.56V0H181.55V11.37H164.16V58.02H152.87V11.37Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.93 0H236.1C247.56 0 255.55 7.83 255.55 18.3C255.55 26.46 250.69 32.89 242.94 35.36L256.04 58.02H243.1L230.66 36.51H218.13V58.02H206.92V0H206.93ZM236.02 25.22C241.38 25.22 244.26 22.42 244.26 18.3C244.26 14.18 241.38 11.38 236.02 11.38H218.14V25.23H236.02V25.22Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.54 15.99L292.8 58.02H280.93L302.44 0H314.64L336.15 58.02H324.28L308.54 15.99Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUltra);
export default __webpack_public_path__ + "static/media/logoUltra.78adf4d3b622593e29233b4c592c06d3.svg";
export { ForwardRef as ReactComponent };